import { lazy } from 'react';
export default class BBMPythonDescriptor  {

static getDescription() {
    return {
      name: 'BBPython',
      component: lazy(() =>  import('./BBPython')),
      label: 'BB Python in the browser (experimental)',
      type:"experimental",
      variables: [
       
        {
          name: 'pythonengine',
          type: 'select',
          options: [
            
            { label: 'stlite', value: 'stlite' },
            { label: 'brython', value: 'brython' }
             , { label: 'javascript (not available)', value: 'javascript' }
          ]
          ,
          label: 'choose python engine. default is STLITE',
          description: '',
         
        },
       
        {
          name: 'pythoncode2',
          type: 'json',
          defaultValue:{},
          label: 'configuration including the python code',
          description: ' configuration including the python code',
         
        },
       
        
      ],
    }
  }
}
